import React from 'react';

export const DEFAULT_ADMIN_COLOR = '#9ca3af';

const COLOR_FIELDS = ['colorHex', 'color', 'fallbackColor'];
const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;

export function getAdminItemColor(item) {
  if (!item || typeof item !== 'object') return null;

  const colorField = COLOR_FIELDS.find((field) => (
    Object.prototype.hasOwnProperty.call(item, field)
  ));
  if (!colorField) return null;

  const color = typeof item[colorField] === 'string'
    ? item[colorField].trim()
    : '';

  return HEX_COLOR_PATTERN.test(color) ? color : DEFAULT_ADMIN_COLOR;
}

export default function AdminColorDot({ item }) {
  const color = getAdminItemColor(item);
  if (!color) return null;

  return (
    <span
      className="admin-color-swatch"
      style={{ backgroundColor: color }}
      aria-hidden="true"
    />
  );
}
